import { config } from '../config';

export namespace TranslationUtils {

    /**
     * Attempts to find the closest tag with a lang attribute.
     * Falls back to Dutch if no language is found.
     * @param element The element to find a lang attribute for.
     */
    export function getLocale(element: HTMLElement = document.body) {
        const storedLocale = localStorage.getItem('lang');
        if (storedLocale) {
            return storedLocale;
        }

        const closestElement = element.closest('[language]') as HTMLElement;
        return closestElement ? closestElement.lang : 'nl';
    }

    export async function fetchTranslations() {
        const locale = getLocale();
        const storageKey = `i18n.${locale}`;
        const expireInMs = 60 * 60 * 1000; // 1 hour in milliseconds

        const storedItem = sessionStorage.getItem(storageKey);
        if (storedItem) {
            const { data, timestamp } = JSON.parse(storedItem);
            const isExpired = Date.now() - timestamp > expireInMs;

            if (!isExpired && data && Object.keys(data).length > 0) {
                return data;
            } else {
                sessionStorage.removeItem(storageKey); // Remove expired data
            }
        }

        try {
            const result = await fetch(`${config.treeviewerUri}/i18n/${locale}.json`);
            if (result.ok) {
                const data = await result.json();
                sessionStorage.setItem(
                    storageKey,
                    JSON.stringify({ data, timestamp: Date.now() })
                );
                return data;
            }
        } catch (exception) {
            console.error(`Error loading locale: ${locale}`, exception);
        }
    }
}